"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PictureInPicture = void 0;
var workerTimers = _interopRequireWildcard(require("worker-timers"));
var _pipUtils = require("./pipUtils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MAX_NUMBER_OF_TILES_IN_PIP = 4;
var DEFAULT_FPS = 30;
var DEFAULT_CANVAS_WIDTH = 900;
var DEFAULT_CANVAS_HEIGHT = 600;
var LEAVE_EVENT_NAME = "leavepictureinpicture";
var PIPStates = {
  starting: "starting",
  started: "started",
  stopping: "stopping",
  stopped: "stopped"
};

/**
 * video elements are stitched together as a canvas which is converted to
 * another video element converted to PIP.
 * The task is split into two parts -
 * 1. a function which gets hit when the input changes and updates the tracks
 * to show
 * 2. an independent loop which updates the canvas periodically based on the current
 * tracks which should be shown.
 */
var PipManager = /*#__PURE__*/function () {
  function PipManager() {
    var _this = this;
    _classCallCheck(this, PipManager);
    _defineProperty(this, "stop", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$pipVideo;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.state === PIPStates.stopped)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this.state = PIPStates.stopping;
              (_this$pipVideo = _this.pipVideo) === null || _this$pipVideo === void 0 ? void 0 : _this$pipVideo.removeEventListener(LEAVE_EVENT_NAME, _this.stop);
              if (_this.timeoutRef) {
                workerTimers.clearTimeout(_this.timeoutRef);
              }
              if (_this.isOn()) {
                _this.exitPIP();
              }
              // detach all to avoid bandwidth consumption
              _context.next = 8;
              return _this.detachOldAttachNewTracks(_this.tracksToShow, []);
            case 8:
              _this.onStateChange(false); // notify parent about this
              _this.reset(); // cleanup
              _this.state = PIPStates.stopped;
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    this.reset();
  }

  /**
   * @private
   */
  _createClass(PipManager, [{
    key: "reset",
    value: function reset() {
      console.debug("resetting PIP state");
      this.canvas = null; // where stitching will take place
      this.pipVideo = null; // the element which will be sent in PIP
      this.timeoutRef = null; // setTimeout reference so it can be cancelled
      this.hmsActions = null; // for attaching detaching
      this.videoElements = []; // for attaching tracks
      this.tracksToShow = [];
      this.onStateChange = function () {}; // for user of this class to listen to changes
      this.state = PIPStates.stopped;
    }

    /**
     * check if PIP is supported in this browser env
     */
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!document.pictureInPictureEnabled;
    }

    /**
     * check if pip is currently turned on
     */
  }, {
    key: "isOn",
    value: function isOn() {
      return !!document.pictureInPictureElement;
    }

    /**
     * request browser to start pip and start the render loop updating the pip
     * video element with peer tracks.
     * @param hmsActions
     * @param onStateChangeFn {function(bool):void} callback called to notify change in pip state
     */
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(hmsActions, onStateChangeFn) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isSupported()) {
                  _context2.next = 2;
                  break;
                }
                throw new Error("pip is not supported on this browser");
              case 2:
                console.debug("starting PIP, current state", this.state);
                if (!(this.state === PIPStates.started)) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 6;
                return this.stop();
              case 6:
                _context2.next = 10;
                break;
              case 8:
                if (!(this.state === PIPStates.starting)) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return");
              case 10:
                this.state = PIPStates.starting;
                _context2.prev = 11;
                _context2.next = 14;
                return this.init(hmsActions, onStateChangeFn);
              case 14:
                // when user closes pip, call internal stop
                this.pipVideo.addEventListener(LEAVE_EVENT_NAME, this.stop);
                this.renderLoop();
                if (this.isOn()) {
                  _context2.next = 19;
                  break;
                }
                _context2.next = 19;
                return this.requestPIP();
              case 19:
                console.debug("pip started");
                this.state = PIPStates.started;
                this.onStateChange(true);
                _context2.next = 28;
                break;
              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](11);
                console.error("error in request pip", _context2.t0);
                this.state = PIPStates.stopped;
              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 24]]);
      }));
      function start(_x, _x2) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "updatePeersAndTracks",
    value: /**
            * @param peers {Array} All Remote Peers present in call.
            * @param tracksMap {Object} map of track id to track
            * */function () {
      var _updatePeersAndTracks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(peers, tracksMap) {
        var newTracksToShowUnordered, currentTracksShowing;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.canvas) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                newTracksToShowUnordered = this.pickTracksToShow(peers, tracksMap);
                currentTracksShowing = this.tracksToShow;
                this.tracksToShow = this.orderNewTracksToShow(newTracksToShowUnordered, currentTracksShowing);
                _context3.prev = 5;
                _context3.next = 8;
                return this.detachOldAttachNewTracks(currentTracksShowing, this.tracksToShow, tracksMap);
              case 8:
                _context3.next = 13;
                break;
              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](5);
                console.error("error in detaching/attaching tracks", _context3.t0);
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 10]]);
      }));
      function updatePeersAndTracks(_x3, _x4) {
        return _updatePeersAndTracks.apply(this, arguments);
      }
      return updatePeersAndTracks;
    }() // ------- Private function --------------
    /**
     * @private
     */
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(hmsActions, onStateChangeFn) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.initMediaElements();
              case 2:
                this.hmsActions = hmsActions;
                this.onStateChange = onStateChangeFn;
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function init(_x5, _x6) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initMediaElements",
    value: function () {
      var _initMediaElements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this$initializeCanva, canvas, pipVideo, videoPlayPromise;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.canvas) {
                  _context5.next = 9;
                  break;
                }
                _this$initializeCanva = this.initializeCanvasAndVideoElement(), canvas = _this$initializeCanva.canvas, pipVideo = _this$initializeCanva.pipVideo;
                this.canvas = canvas; // where stitching will take place
                this.pipVideo = pipVideo; // the element which will be sent in PIP
                this.videoElements = this.initializeVideoElements(); // for attaching tracks
                videoPlayPromise = this.pipVideo.play();
                (0, _pipUtils.dummyChangeInCanvas)(this.canvas);
                _context5.next = 9;
                return videoPlayPromise;
              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function initMediaElements() {
        return _initMediaElements.apply(this, arguments);
      }
      return initMediaElements;
    }()
  }, {
    key: "initializeCanvasAndVideoElement",
    value: function initializeCanvasAndVideoElement() {
      var canvas = document.createElement("canvas");
      canvas.width = DEFAULT_CANVAS_WIDTH;
      canvas.height = DEFAULT_CANVAS_HEIGHT;
      var pipVideo = document.createElement("video");
      pipVideo.muted = true;
      pipVideo.srcObject = canvas.captureStream();
      return {
        canvas: canvas,
        pipVideo: pipVideo
      };
    }
  }, {
    key: "initializeVideoElements",
    value: function initializeVideoElements() {
      var videoElements = [];
      for (var i = 0; i < MAX_NUMBER_OF_TILES_IN_PIP; i++) {
        var videoElement = document.createElement("video");
        videoElement.autoplay = true;
        videoElement.playsinline = true;
        videoElements.push(videoElement);
      }
      return videoElements;
    }

    /**
     * render loop is responsible for rendering the video elements on canvas/pip.
     * in each loop current video elements are stitched and painted on canvas
     */
  }, {
    key: "renderLoop",
    value: function renderLoop() {
      var _this2 = this;
      var delay = 1000 / DEFAULT_FPS;
      this.timeoutRef = workerTimers.setTimeout(function () {
        if (_this2.state === PIPStates.stopping || _this2.state === PIPStates.stopped) {
          return;
        }
        if (_this2.state === PIPStates.started) {
          (0, _pipUtils.drawVideoElementsOnCanvas)(_this2.videoElements, _this2.canvas);
        }
        _this2.renderLoop();
      }, delay);
    }
  }, {
    key: "requestPIP",
    value: function () {
      var _requestPIP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                if (this.isOn()) {
                  this.exitPIP(); // is this really needed?
                }
                _context6.next = 4;
                return this.pipVideo.requestPictureInPicture();
              case 4:
                _context6.next = 10;
                break;
              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                console.error("error in requestpip", _context6.t0, "state", this.state);
                throw _context6.t0;
              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));
      function requestPIP() {
        return _requestPIP.apply(this, arguments);
      }
      return requestPIP;
    }()
  }, {
    key: "exitPIP",
    value: function exitPIP() {
      document.exitPictureInPicture();
    }

    /**
     * Logic - pick only enabled video tracks
     * @param peers {Array<any>}
     * @param tracksMap {Record<string, any>}
     */
  }, {
    key: "pickTracksToShow",
    value: function pickTracksToShow(peers, tracksMap) {
      var tracksToShow = [];
      var _iterator = _createForOfIteratorHelper(peers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _tracksMap$peer$video;
          var peer = _step.value;
          if (tracksToShow.length === MAX_NUMBER_OF_TILES_IN_PIP) {
            break;
          } else if (peer.videoTrack && (_tracksMap$peer$video = tracksMap[peer.videoTrack]) !== null && _tracksMap$peer$video !== void 0 && _tracksMap$peer$video.enabled) {
            tracksToShow.push(peer.videoTrack);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return tracksToShow;
    }

    /**
     * there has to be a smart reordering of new tracks based on currently showing
     * ones to reduce unnecessary displacement. If someone was showing up both
     * earlier and now, it's a better UX to keep their position same instead
     * of letting it change.
     * The returned array is a shuffled version of newTracks with position of
     * tracks present in the old tracks intact.
     * eg. old = [1,5,9,3], new = [3,8,2,9], result = [8,2,9,3]
     * @param oldTracks {Array}
     * @param newTracks {Array}
     * @return {Array}
     */
  }, {
    key: "orderNewTracksToShow",
    value: function orderNewTracksToShow(newTracks, oldTracks) {
      var betterNewTracks = [];
      var leftOvers = [];
      // put the common ones in right position
      newTracks.forEach(function (track) {
        var oldPosition = oldTracks.indexOf(track);
        if (oldPosition !== -1 && oldPosition < newTracks.length) {
          // if track is there currently and we can put it on the same position
          betterNewTracks[oldPosition] = track;
        } else {
          leftOvers.push(track);
        }
      });
      // put the left overs in remaining empty positions
      for (var i = 0; i < newTracks.length; i++) {
        if (!betterNewTracks[i]) {
          betterNewTracks[i] = leftOvers.shift();
        }
      }
      return betterNewTracks;
    }

    /**
     * call detach for tracks which no longer need to be shown and attach for
     * new ones which are to be shown now.
     * Note: oldTracks and newTracks are not necessarily of same length
     * @param oldTracks {Array<String>}
     * @param newTracks {Array<String>}
     * @param tracksMap {Record<String, any>}
     */
  }, {
    key: "detachOldAttachNewTracks",
    value: function () {
      var _detachOldAttachNewTracks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(oldTracks, newTracks) {
        var tracksMap,
          numTracks,
          i,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                tracksMap = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
                numTracks = Math.max(oldTracks.length, newTracks.length);
                i = 0;
              case 3:
                if (!(i < numTracks)) {
                  _context7.next = 19;
                  break;
                }
                if (!(oldTracks[i] === newTracks[i])) {
                  _context7.next = 8;
                  break;
                }
                return _context7.abrupt("continue", 16);
              case 8:
                if (!oldTracks[i]) {
                  _context7.next = 13;
                  break;
                }
                if (!(!tracksMap || tracksMap[oldTracks[i]])) {
                  _context7.next = 12;
                  break;
                }
                _context7.next = 12;
                return this.hmsActions.detachVideo(oldTracks[i], this.videoElements[i]);
              case 12:
                if (this.videoElements[i]) {
                  // even if old track got removed from the room, element needs to be cleaned up
                  this.videoElements[i].srcObject = null;
                }
              case 13:
                if (!newTracks[i]) {
                  _context7.next = 16;
                  break;
                }
                _context7.next = 16;
                return this.hmsActions.attachVideo(newTracks[i], this.videoElements[i]);
              case 16:
                i++;
                _context7.next = 3;
                break;
              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function detachOldAttachNewTracks(_x7, _x8) {
        return _detachOldAttachNewTracks.apply(this, arguments);
      }
      return detachOldAttachNewTracks;
    }()
  }]);
  return PipManager;
}();
var PictureInPicture = new PipManager();
// PictureInPicture.initMediaElements().catch(console.error);  // for safari, init early
exports.PictureInPicture = PictureInPicture;